<template>
  <div class="container mt-1 border rounded midtxt">
    <div class="row">
      <div class="col fw-bold">Settings</div>
      <div class="col">
        <i
          class="bi bi-chevron-double-down float-end"
          v-if="!expand"
          @click="toggleExpand()"
        ></i>
        <i
          class="bi bi-chevron-double-up text-danger float-end"
          v-if="expand"
          @click="toggleExpand()"
        ></i>
      </div>
    </div>
    <div v-if="expand">
      <div class="row" v-if="msg">
        <div class="col bg-info rounded">{{ msg }}</div>
      </div>

      <div class="row fw-bold">
        <div class="col">Name</div>
        <div class="col">Wallet</div>
        <div class="col">BasePrice</div>
        <div class="col">Increment</div>

        <div class="col">IncrementCount</div>
        <div class="col">TeamSize</div>
        <div class="col">ToPurchase</div>
        <div class="col">Timer</div>
        <div class="col">Blank <br />Timer</div>
        <div class="col">
          Auctioneer <br />
          Bidding
        </div>
        <div class="col">Flash <br />Bidding</div>
        <div class="col">
          Select <br />
          LivePlayer
        </div>
        <!-- <div class="col">
          Hard <br />
          Sale
        </div> -->
      </div>
      <div class="row d-flex align-items-center" v-if="auction.id">
        <div class="col">
          <input
            type="text"
            class="form-control"
            v-model.trim="auction_name"
            @keyup.enter="updateAuctionName()"
          />
        </div>
        <div class="col">
          <input
            type="text"
            class="form-control"
            v-model="wallet_size"
            @keyup.enter="updateWalletSize()"
          />
        </div>
        <div class="col">
          <input
            type="text"
            class="form-control"
            v-model="base_price"
            @keyup.enter="updateBasePrice()"
          />
        </div>
        <div class="col">
          <input
            type="text"
            class="form-control"
            v-model="bid_increment"
            @keyup.enter="updateBidIncrement()"
          />
        </div>
        <div class="col d-flex justify-content-evenly">
          <i class="bi bi-dash-lg" @click="incrementCountTick(-1)"></i>
          <span>{{ auction.increment_count }}</span>
          <i class="bi bi-plus-lg" @click="incrementCountTick(1)"></i>
        </div>
        <div class="col">
          <input
            type="text"
            class="form-control"
            v-model="team_size"
            @keyup.enter="updateTeamSize()"
          />
        </div>
        <div class="col">
          <input
            type="text"
            class="form-control"
            v-model="to_purchase"
            @keyup.enter="updateToPurchase()"
          />
        </div>
        <div class="col d-flex justify-content-evenly">
          <i class="bi bi-dash-lg" @click="incrementTimer(-5)"></i>
          {{ auction.timer }}
          <i class="bi bi-plus-lg" @click="incrementTimer(5)"></i>
        </div>
        <div class="col">
          <button
            class="btn btn-sm btn-danger"
            v-if="!auction.blank_timer"
            @click="toggleBlankTimer()"
          >
            OFF
          </button>
          <button
            class="btn btn-sm btn-success"
            v-else
            @click="toggleBlankTimer()"
          >
            ON
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-sm btn-danger"
            v-if="!auction.enable_assist"
            @click="toggleAssist()"
          >
            OFF
          </button>
          <button class="btn btn-sm btn-success" v-else @click="toggleAssist()">
            ON
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-sm btn-danger"
            v-if="!auction.enable_flash"
            @click="toggleFlash()"
          >
            OFF
          </button>
          <button class="btn btn-sm btn-success" v-else @click="toggleFlash()">
            ON
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-sm btn-danger"
            v-if="!auction.select_live_player"
            @click="toggleSelectLive()"
          >
            OFF
          </button>
          <button
            class="btn btn-sm btn-success"
            v-else
            @click="toggleSelectLive()"
          >
            ON
          </button>
        </div>
        <!-- <div class="col">
          <button
            class="btn btn-sm btn-danger"
            v-if="!auction.hard_sale"
            @click="toggleHardSale()"
          >
            OFF
          </button>
          <button
            class="btn btn-sm btn-success"
            v-else
            @click="toggleHardSale()"
          >
            ON
          </button>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script setup>
import supabase from "@/supabase/config";
import { onMounted, ref } from "vue";
import { useStore } from "@/store/index";
const store = useStore();
const expand = ref(false);
const auction = ref({});
const auction_name = ref("");
const wallet_size = ref(0);
const bid_increment = ref(0);
const base_price = ref(0);
const team_size = ref(0);
const to_purchase = ref(0);
const msg = ref("");
const updateAuctionName = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ name: auction_name.value })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    fetchAuction();
    msg.value = "Name updated to: " + auction_name.value;
    setTimeout(() => {
      msg.value = "";
    }, 2000);
  }
};
const updateBidIncrement = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ bid_increment: bid_increment.value })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    fetchAuction();
    msg.value = "Bid increment updated to: " + bid_increment.value;
    setTimeout(() => {
      msg.value = "";
    }, 2000);
  }
};
const updateWalletSize = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ wallet_size: wallet_size.value })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    fetchAuction();
    msg.value = "Wallet limit updated to: " + wallet_size.value;
    setTimeout(() => {
      msg.value = "";
    }, 2000);
  }
};
const updateBasePrice = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ base_price: base_price.value })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    fetchAuction();
    msg.value = "Base price updated to: " + base_price.value;
    setTimeout(() => {
      msg.value = "";
    }, 2000);
  }
};

const updateToPurchase = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ to_purchase: to_purchase.value })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    fetchAuction();
    msg.value = "To purchase updated to: " + to_purchase.value;
    setTimeout(() => {
      msg.value = "";
    }, 2000);
  }
};
const updateTeamSize = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ team_size: team_size.value })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    fetchAuction();
    msg.value = "Team Size updated to: " + team_size.value;
    setTimeout(() => {
      msg.value = "";
    }, 2000);
  }
};
const toggleExpand = () => {
  expand.value = !expand.value;
};
onMounted(() => {
  setTimeout(() => {
    fetchAuction();
  }, 1000);
});
const fetchAuction = async () => {
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  auction.value = auctions[0];
  auction_name.value = auction.value.name;
  wallet_size.value = auction.value.wallet_size;
  bid_increment.value = auction.value.bid_increment;
  team_size.value = auction.value.team_size;
  base_price.value = auction.value.base_price;
};
const editAuction = async () => {
  msg.value = "Updating Auction";
  console.log({
    name: auction_name.value,
    wallet_size: wallet_size.value,
    bid_increment: bid_increment.value,
    team_size: team_size.value,
  });
  const { data, error } = await supabase
    .from("auctions")
    .update({
      name: auction_name.value,
      wallet_size: wallet_size.value,
      bid_increment: bid_increment.value,
      team_size: team_size.value,
    })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    msg.value = "Auction updated!";
    fetchAuction();
  } else {
    msg.value = error.message;
  }
  setTimeout(() => {
    msg.value = "";
  }, 3000);
};
const incrementCountTick = async (val) => {
  // console.log(auction.value.increment_count + val);
  var new_value = auction.value.increment_count + val;
  if (new_value < 1) {
    new_value = 1;
  }

  const { data, error } = await supabase
    .from("auctions")
    .update({ increment_count: new_value })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    fetchAuction();
  }
};
const incrementTimer = async (val) => {
  // console.log(auction.value.increment_count + val);
  var new_value = auction.value.timer + val;
  if (new_value < 0) {
    new_value = 0;
  }

  const { data, error } = await supabase
    .from("auctions")
    .update({ timer: new_value })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    fetchAuction();
  }
};
const toggleAssist = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ enable_assist: !auction.value.enable_assist })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    fetchAuction();
  }
};
const toggleFlash = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ enable_flash: !auction.value.enable_flash })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    fetchAuction();
  }
};
const toggleBlankTimer = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ blank_timer: !auction.value.blank_timer })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    fetchAuction();
  }
};
const toggleSelectLive = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ select_live_player: !auction.value.select_live_player })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    fetchAuction();
  }
};
const toggleHardSale = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ hard_sale: !auction.value.hard_sale })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    fetchAuction();
  }
};
</script>
<style scoped>
.midtxt {
  font-size: 12px;
}
.form-control {
  font-size: 10px;
  padding: 2px;
}
.btn-sm {
  padding: 2px;
  font-size: 12px;
}
</style>
